module.exports = __webpack_public_path__ + "img/wechat.8c41cc7b.svg";